<script setup lang="ts">
definePageMeta({ layout: false })
import { onMounted } from 'vue'
import { useRouter } from '#app'

const router = useRouter()

onMounted(() => {
  setTimeout(() => {
    router.push('/')
  }, 2000)
})
</script>

<template>
  <div class="container-fluid my-5 gap-5 text-center d-flex flex-column align-items-center justify-content-center">
    <h2 class="text-primary display-1">404</h2>
    <button class="btn btn-primary" disabled>Pagina não existente, redirecionando para o início</button>
  </div>
</template>